import { httpLastTickets, httpReadApi } from './http';
import gameHeaders from './headers';

export default {
  getEndpoint(platformName) {
    const platform = platformName ? platformName.toUpperCase() : 'SEVEN';
    const path = `VUE_APP_${platform}_TICKETS_HISTORY_PATH`;
    return process.env[path];
  },
  getTicketsHistory(config, user, { dateFrom, dateTo }) {
    const { platformName, productName } = config;
    let url = this.getEndpoint(platformName);
    if (platformName === 'NextGen') url = this.interpolateUrl(url, user.profile);
    const params = {
      seven: {
        count: 1000,
        id_language: config.locale,
        product: productName.split(' ').join(''),
        timeFrom: dateFrom,
        timeTo: dateTo,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      playtech: {
        product: productName.split(' ').join(''),
        player: user.profile.username,
        cpvUuid: config.productId,
        startDate: dateFrom,
        endDate: dateTo,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      NextGen: {
        count: 1000,
        id_language: config.locale,
        product: productName.split(' ').join(''),
        timeFrom: dateFrom,
        timeTo: dateTo,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
    };

    const headers = {
      ...gameHeaders.getAuthHeader(user, config),
      ...gameHeaders.getNgsHeaders(config, user),
    };

    return httpLastTickets(config).get(url, { params: params[platformName], headers });
  },
  getTicketHistoryFromReadApi(config, user, payload) {
    const { productName, tenantId } = config;
    const { id, token } = user.profile;
    const { dateFrom, dateTo } = payload;

    const headers = {
      authorization: `Bearer ${token}`,
      'X-Nsft-Games-Tenant-Id': tenantId,
      'X-Nsft-Games-Product-Name': productName,
    };

    const params = {
      tenants: tenantId,
      products: productName,
      size: 100,
      page: 1,
      dateFrom: new Date(dateFrom).toISOString(),
      dateTo: new Date(dateTo).toISOString(),
    };
    return httpReadApi().get(`tickets/players/${id}`, { headers, params });
  },
  // USED TO POPULATE VALUES INSIDE {} curly brackets in url
  interpolateUrl(url, config) {
    return url.replace(/{([^}]+)}/g, (match, key) => (Object.prototype.hasOwnProperty.call(config, key) ? config[key] : match));
  },
};
